import React, { useState, useEffect } from "react";
import lessons from "./LessonsHindi.json";
import LessonList from "./LessonList";
import "./LessonsHindi.css";

function LessonsHindi() {
  const [selectedConcept, setSelectedConcept] = useState(null);

  useEffect(() => {
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length === 0) {
        setTimeout(loadVoices, 100);
      }
    };
    loadVoices();
  }, []);

  const speak = (text, langCode) => {
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();
    const voice = voices.find(v => v.lang === langCode);

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = langCode;
    if (voice) utterance.voice = voice;

    synth.speak(utterance);
  };

  const handleSelect = (event) => {
    const conceptId = parseInt(event.target.value);
    const concept = lessons.find((c) => c.id === conceptId);
    setSelectedConcept(concept);
  };

  return (
    <div className="app">
      <h1>Learn Hindi, English & Telugu Easily in Hours</h1>
      <select onChange={handleSelect} defaultValue="">
        <option value="" disabled>Select a Concept</option>
        {lessons.map((concept) => (
          <option key={concept.id} value={concept.id}>
            {concept.concept}
          </option>
        ))}
      </select>

      {selectedConcept && (
        <div className="lesson-container">
          <LessonList subconcepts={selectedConcept.subconcepts} />

          {/* English */}
          {selectedConcept.english && (
            <div className="language-block">
              <h2>{selectedConcept.english.title}</h2>
              {selectedConcept.english.lines?.map((line, i) => <p key={i}>{line}</p>)}
              <button onClick={() => speak(selectedConcept.english.lines.join(" "), "en-US")}>
                🔊 Read Aloud (English)
              </button>
            </div>
          )}

          {/* Hindi */}
          {selectedConcept.hindi && (
            <div className="language-block">
              <h2>{selectedConcept.hindi.title}</h2>
              {selectedConcept.hindi.lines?.map((line, i) => <p key={i}>{line}</p>)}
              <button onClick={() => speak(selectedConcept.hindi.lines.join(" "), "hi-IN")}>
                🔊 Read Aloud (Hindi)
              </button>
            </div>
          )}

          {/* Telugu */}
          {selectedConcept.telugu && (
            <div className="language-block">
              <h2>{selectedConcept.telugu.title}</h2>
              {selectedConcept.telugu.lines?.map((line, i) => <p key={i}>{line}</p>)}
              <button onClick={() => speak(selectedConcept.telugu.lines.join(" "), "te-IN")}>
                🔊 Read Aloud (Telugu)
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default LessonsHindi;
